import { Routes } from '@angular/router';
import { TherapistListComponent } from './client-portal/therapist-list/therapist-list.component';
import { BookingDetailsComponent } from './client-portal/booking-details/booking-details.component';
import { QueueComponent } from './client-portal/queue/queue.component';
import { DashboardComponent } from './admin/dashboard/dashboard.component';
import { LogInComponent } from './log-in/log-in.component';
import { ClientPortalLayoutComponent } from './layouts/client-portal/client-portal.component';
import { AdminLayoutComponent } from './layouts/admin/admin.component';
import { TherapistAdminListComponent } from './admin/therapists/therapist-list/therapist-list.component';
import { TherapistAddEditComponent } from './admin/therapists/therapist-add-edit/therapist-add-edit.component';
import { BookingListComponent } from './admin/bookings/booking-list/booking-list.component';
import { TherapistPortalLayoutComponent } from './layouts/therapist-portal/therapist-portal.component';
import { TherapistDashboardComponent } from './therapist-poral/dashboard/dashboard.component';
import { AdminAuthGuard } from './guards/admin-auth.guard';
import { TherapistAuthGuard } from './guards/therapist-auth.guard';
import { QueueMineComponent } from './therapist-poral/queue/queue-mine/queue-mine.component';
import { QueueAnyComponent } from './therapist-poral/queue/queue-any/queue-any.component';
import { ClockedInTherapistsComponent } from './admin/therapists/therapist-list/clocked-in-therapists/clocked-in-therapists.component';
import { OnBreakTherapistsComponent } from './admin/therapists/therapist-list/on-break-therapists/on-break-therapists.component';
import { OnMassageTherapistsComponent } from './admin/therapists/therapist-list/on-massage-therapists/on-massage-therapists.component';
import { WaitingTherapistsComponent } from './admin/therapists/therapist-list/waiting-therapists/waiting-therapists.component';
import { QuickCreateBookingComponent } from './therapist-poral/quick-create-booking/quick-create-booking.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { EventListComponent } from './client-portal/event-list/event-list.component';
import { ActiveUpcomingEventsComponent } from './admin/events/active-upcoming-events/active-upcoming-events.component';
import { AllEventsComponent } from './admin/events/all-events/all-events.component';
import { EventDashboardComponent } from './admin/events/event-dashboard/event-dashboard.component';
import { EventTherapistsClockedInComponent } from './admin/events/event-dashboard/event-therapists/event-therapists-clocked-in/event-therapists-clocked-in.component';
import { EventTherapistsOnBreakComponent } from './admin/events/event-dashboard/event-therapists/event-therapists-on-break/event-therapists-on-break.component';
import { EventTherapistsOnMassageComponent } from './admin/events/event-dashboard/event-therapists/event-therapists-on-massage/event-therapists-on-massage.component';
import { EventTherapistsWaitingComponent } from './admin/events/event-dashboard/event-therapists/event-therapists-waiting/event-therapists-waiting.component';
import { EventBookingsComponent } from './admin/events/event-dashboard/event-bookings/event-bookings.component';
import { EventTherapistsComponent } from './admin/events/event-dashboard/event-therapists/event-therapists.component';
import { EventTherapistsAllComponent } from './admin/events/event-dashboard/event-therapists/event-therapists-all/event-therapists-all.component';


export const routes: Routes = [
  {
    path: '', redirectTo: 'client-portal', pathMatch: 'full'
  },
  {
    path: 'client-portal',
    component: ClientPortalLayoutComponent,
    children: [
      { path: '', redirectTo: 'event-list', pathMatch: 'full' },
      { path: 'event-list', component: EventListComponent },
      { path: 'therapist-list', component: TherapistListComponent },
      { path: 'book/:guid', component: BookingDetailsComponent },
      { path: 'book', component: BookingDetailsComponent },
      { path: 'queue/:guid', component: QueueComponent },
      { path: 'queue', component: QueueComponent },

      // Catch-all unknown routes inside /client-portal
      { path: '**', redirectTo: 'event-list' }
    ]
  },
  {
    path: 'login', component: LogInComponent
  },
  {
    path: 'admin',
    component: AdminLayoutComponent,
    canActivate: [AdminAuthGuard],
    children: [
      { path: '', redirectTo: 'login', pathMatch: 'full' },

      {path:'events', component: ActiveUpcomingEventsComponent, canActivate: [AdminAuthGuard]},
      {path: 'events/all-events', component: AllEventsComponent, canActivate: [AdminAuthGuard]},
      {path: 'events/:id', component: EventDashboardComponent, canActivate: [AdminAuthGuard]},
      {path: 'events/:id/therapists/clocked-in', component: EventTherapistsClockedInComponent, canActivate: [AdminAuthGuard]},
      {path: 'events/:id/therapists/all', component: EventTherapistsAllComponent, canActivate: [AdminAuthGuard]},
      {path: 'events/:id/therapists/on-break', component: EventTherapistsOnBreakComponent, canActivate: [AdminAuthGuard]},
      {path: 'events/:id/therapists/on-massage', component: EventTherapistsOnMassageComponent, canActivate: [AdminAuthGuard]},
      {path: 'events/:id/therapists/waiting', component: EventTherapistsWaitingComponent, canActivate: [AdminAuthGuard]},
      {path: 'events/:id/therapists', component: EventTherapistsComponent, canActivate: [AdminAuthGuard]},
      {path: 'events/:id/bookings', component: EventBookingsComponent, canActivate: [AdminAuthGuard]},



      { path: 'dashboard', component: DashboardComponent, canActivate: [AdminAuthGuard] },
      { path: 'therapists', component: TherapistAdminListComponent, canActivate: [AdminAuthGuard]  },
      // { path: 'therapists/clocked-in', component: ClockedInTherapistsComponent, canActivate: [AdminAuthGuard] },
      // { path: 'therapists/on-break', component: OnBreakTherapistsComponent, canActivate: [AdminAuthGuard] },
      // { path: 'therapists/on-massage', component: OnMassageTherapistsComponent, canActivate: [AdminAuthGuard] },
      // { path: 'therapists/waiting', component: WaitingTherapistsComponent, canActivate: [AdminAuthGuard] },
      { path: 'therapists/manage/:id', component: TherapistAddEditComponent, canActivate: [AdminAuthGuard]  },
      { path: 'therapists/add', component: TherapistAddEditComponent, canActivate: [AdminAuthGuard]  },
      // { path: 'bookings', component: BookingListComponent, canActivate: [AdminAuthGuard]  },

      { path: '**', redirectTo: 'login' } // catch-all inside admin
    ]
  },
  {
    path: 'therapist-portal',
    component: TherapistPortalLayoutComponent,
    canActivate: [TherapistAuthGuard],
    children: [
      { path: 'dashboard', component: TherapistDashboardComponent, canActivate: [TherapistAuthGuard] },
      { path: 'quick-create-booking', component: QuickCreateBookingComponent, canActivate: [TherapistAuthGuard] },
      { path: 'queue/my-queue', component: QueueMineComponent, canActivate: [TherapistAuthGuard]},
      { path: 'queue/any-queue', component: QueueAnyComponent, canActivate: [TherapistAuthGuard]},

    ]

  },
  {
      path: 'privacy',
      component: PrivacyComponent,
  },
  {
      path: 'booknow',
      redirectTo: 'client-portal'
  },
  {
  path: '**',
  redirectTo: 'client-portal' 
  }
];
